import { FormControl } from "@angular/forms";

export function StreetNumberValidator(control: FormControl) {
	if (control.value) {
		const streetNumberRegEx =
			/^(?!^[- ])(?!.*[- ]$)(([a-zA-Z0-9])+[-|\s]?([a-zA-Z0-9])*)*$/;
		const valid = streetNumberRegEx.test(control.value);
		if (!valid) {
			return {
				streetNumberInvalid: {
					valid: false,
					message: "Invalid street #",
				},
			};
		}
		return null;
	}
}
